import { useState, type ReactNode } from 'react';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';

type DashboardShellProps = {
  title: string;
  children: ReactNode;
  role: 'admin' | 'teacher';
};

export function DashboardShell({ title, children, role }: DashboardShellProps) {
  const STORAGE_KEY = 'ams:sidebar-collapsed';
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const [isDesktopSidebarCollapsed, setIsDesktopSidebarCollapsed] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved !== null ? JSON.parse(saved) : false;
    } catch (e) {
      console.error('Error reading sidebar state:', e);
      return false;
    }
  });

  const handleCloseMobileSidebar = () => setIsMobileSidebarOpen(false);
  
  const handleToggleSidebar = () => {
    if (window.innerWidth >= 1024) {
      const next = !isDesktopSidebarCollapsed;
      setIsDesktopSidebarCollapsed(next);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } else {
      setIsMobileSidebarOpen((prev) => !prev);
    }
  };

  return (
    <div className="flex min-h-screen bg-slate-100">
      <Sidebar 
        role={role} 
        isOpen={isMobileSidebarOpen} 
        isCollapsed={isDesktopSidebarCollapsed}
        onClose={handleCloseMobileSidebar} 
      />
      <div className="flex flex-1 flex-col overflow-hidden">
        <TopBar title={title} onToggleSidebar={handleToggleSidebar} />
        <main className="flex-1 overflow-auto px-3 py-4 sm:px-6 sm:py-6">
          <div className="mx-auto w-full max-w-7xl">{children}</div>
        </main>
      </div>
    </div>
  );
}
